// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/settings.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/settings.proto.
 */
export const file_travplaces_v1_settings: GenFile = /*@__PURE__*/
  fileDesc("Chx0cmF2cGxhY2VzL3YxL3NldHRpbmdzLnByb3RvEg10cmF2cGxhY2VzLnYxIioKB1NldHRpbmcSCwoDa2V5GAEgASgJEhIKCnZhbHVlX2pzb24YAiABKAkiFQoTTGlzdFNldHRpbmdzUmVxdWVzdCJAChRMaXN0U2V0dGluZ3NSZXNwb25zZRIoCghzZXR0aW5ncxgBIAMoCzIWLnRyYXZwbGFjZXMudjEuU2V0dGluZzJ3Cg9TZXR0aW5nc1NlcnZpY2USZAoMTGlzdFNldHRpbmdzEiIudHJhdnBsYWNlcy52MS5MaXN0U2V0dGluZ3NSZXF1ZXN0GiMudHJhdnBsYWNlcy52MS5MaXN0U2V0dGluZ3NSZXNwb25zZSILiuowAwoBCpDqMAFCqAEKEWNvbS50cmF2cGxhY2VzLnYxQg1TZXR0aW5nc1Byb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * Setting is one global key/value configuration row. The value is a JSON
 * document rendered as a string (the raw jsonb payload), e.g. "45", "true",
 * or "\"https://…\"".
 *
 * @generated from message travplaces.v1.Setting
 */
export type Setting = Message<"travplaces.v1.Setting"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * raw jsonb value, JSON-encoded
   *
   * @generated from field: string value_json = 2;
   */
  valueJson: string;
};

/**
 * Describes the message travplaces.v1.Setting.
 * Use `create(SettingSchema)` to create a new message.
 */
export const SettingSchema: GenMessage<Setting> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_settings, 0);

/**
 * @generated from message travplaces.v1.ListSettingsRequest
 */
export type ListSettingsRequest = Message<"travplaces.v1.ListSettingsRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListSettingsRequest.
 * Use `create(ListSettingsRequestSchema)` to create a new message.
 */
export const ListSettingsRequestSchema: GenMessage<ListSettingsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_settings, 1);

/**
 * @generated from message travplaces.v1.ListSettingsResponse
 */
export type ListSettingsResponse = Message<"travplaces.v1.ListSettingsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.Setting settings = 1;
   */
  settings: Setting[];
};

/**
 * Describes the message travplaces.v1.ListSettingsResponse.
 * Use `create(ListSettingsResponseSchema)` to create a new message.
 */
export const ListSettingsResponseSchema: GenMessage<ListSettingsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_settings, 2);

/**
 * SettingsService exposes the global key/value settings catalogue.
 *
 * @generated from service travplaces.v1.SettingsService
 */
export const SettingsService: GenService<{
  /**
   * ListSettings returns every setting, ordered by key.
   *
   * @generated from rpc travplaces.v1.SettingsService.ListSettings
   */
  listSettings: {
    methodKind: "unary";
    input: typeof ListSettingsRequestSchema;
    output: typeof ListSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_settings, 0);

